'use client';

import Link from 'next/link';
import type { ServiceCardProps } from '@routeroyal/theme-core';

/**
 * Stone Investment Service Card
 * 
 * Minimal service card with sophisticated styling
 */
export function StoneInvestmentServiceCard({ service }: ServiceCardProps) {
  const content = (
    <div className="group p-8 border border-[var(--color-border)] hover:border-[var(--color-text)] transition-all duration-300 h-full">
      {/* Icon */}
      {service.icon && (
        <div className="w-12 h-12 border border-[var(--color-border)] flex items-center justify-center mb-6 group-hover:border-[var(--color-text)] transition-colors duration-300">
          <span className="text-lg">{service.icon}</span>
        </div>
      )}
      
      {/* Title */}
      <h3 
        className="text-xl lg:text-2xl text-[var(--color-text)] mb-4 group-hover:text-[var(--color-text-muted)] transition-colors duration-300"
        style={{ 
          fontFamily: "'Cormorant Garamond', 'Georgia', serif",
          fontWeight: 400,
        }}
      >
        {service.title}
      </h3>
      
      {/* Description */}
      <p 
        className="text-[var(--color-text-muted)] text-sm leading-relaxed"
        style={{ fontFamily: "'DM Sans', sans-serif" }}
      >
        {service.description}
      </p>
    </div>
  );

  if (service.link) {
    return (
      <Link href={service.link} className="block h-full">
        {content}
      </Link>
    );
  }

  return content;
}
